import React from "react";
import { Handshake, Map, Search } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const advantages = [{
  title: "Flexible Itineraries",
  description: "Your journey, your pace. We customize every route to ensure you spend more time at the hidden gems that truly captivate your spirit.",
  icon: Map
}, {
  title: "Expert Local Guides",
  description: "Led by Jim Yang and our team of specialists, gain deep insights into Guizhou's history and traditions that only a local can provide.",
  icon: Handshake
}, {
  title: "Cultural Immersion",
  description: "Go beyond the surface with authentic encounters in ethnic Miao and Dong villages, experiencing living heritage firsthand.",
  icon: Search
}];
export default function TheNeighborlyAdvantage() {
  return <section data-section-id="223484" id="why-choose-private-tours" className="w-full bg-background py-20 md:py-28 text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="rounded-3xl bg-accent/30 px-6 py-16 md:px-12 md:py-20 lg:px-16 relative overflow-hidden">
          {}
          <div className="absolute inset-0 opacity-5 pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1623046/img/miao_silver_pattern.png')] bg-repeat bg-center"></div>
          
          <div className="mx-auto mb-16 max-w-2xl text-center relative z-10">
            <h2 className="font-default text-3xl font-bold tracking-tight text-primary md:text-4xl">
              Why Choose Private Tours
            </h2>
            <p className="mt-4 text-lg text-muted-foreground font-default">
              Discover the Guizhou Voyage difference through personalized service and authentic local expertise.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-8 md:grid-cols-3 relative z-10">
            {advantages.map((item, i) => {
            const Icon = item.icon;
            return <Card key={i} data-index={i} className="group border border-border/50 bg-card/80 backdrop-blur-sm shadow-sm transition-all duration-300 hover:border-secondary hover:shadow-lg rounded-xl">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary transition-transform duration-300 ease-out group-hover:-translate-y-2">
                      <Icon className="h-8 w-8 stroke-[1.25]" />
                    </div>
                    <CardTitle className="font-default text-xl font-bold text-primary">
                      <h3>{item.title}</h3>
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="leading-relaxed text-muted-foreground font-default text-sm">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </div>
    </section>;
}